import { styled } from '@mui/system'
import { Typography as TypographyBase } from '@mui/material'

export const Typography = styled(TypographyBase)(({ theme }) => ({
  fontSize: theme.typography.fontSize,
}))
